import {
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  Theme,
  Typography,
} from "@yuno/design-system-web";
import { useTranslation } from "react-i18next";

const MENU_PROPS = {
  style: {
    marginLeft: "8px",
  },
};

export const GenericSelect = ({
  value,
  onChange,
  options,
  label = "",
  i18n = null,
  i18FromValues = false,
}) => {
  const { t } = useTranslation();
  return (
    <FormControl fullWidth style={{ marginBottom: "24px" }}>
      <InputLabel id="checkbox-label">{i18n ? t(i18n) : label}</InputLabel>
      <Select
        labelId="checkbox-label"
        id="checkbox"
        value={value}
        onChange={onChange}
        MenuProps={MENU_PROPS}
        IconComponent={(props) => (
          <Icon name="CaretDown" weight="thin" color="#6C6F75" {...props} />
        )}
      >
        {options.map((option, key) => (
          <MenuItem key={key} value={option.value}>
            {i18FromValues ? t(option.label) : option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
